import React from 'react';
import AdminConsoleHeader from "../Admin/AdminConsoleHeader";
import OrderAdminList from "../Admin/Order/OrderAdminList";
import OrderAdminSearch from "../Admin/Order/OrderAdminSearch";
import ObjCommonFilterSelection from "../../component/custom/ObjCommonFilterSelection";
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';

const OrderAdmin = () => {
  const { translation:t } = System;

  const { adminConsoleTab: { MainTab } } = Constants

  return (
    <div className='adminconsole-container orderadmin-container'>
      <AdminConsoleHeader title={t('ORDERADMIN')} tab={MainTab} />
      <OrderAdminSearch />
      <ObjCommonFilterSelection />
      <div className="bs5 row mt-2">
      </div>
      <OrderAdminList />
    </div>
  );
}

export default OrderAdmin;